import { createFileRoute } from '@tanstack/react-router';
import RuleSets from 'containers/RuleSets';

export const Route = createFileRoute('/_authenticated/ruleSets')({
  component: RuleSets,
});
